export const getEmail = () => {
  try {
    const cache = localStorage.getItem('mage-cache-storage');
    // @ts-expect-error // TODO: fix types
    const storage = JSON.parse(cache);
    return storage?.customer?.email ?? null;
  } catch (err) {
    console.log('cannot get email', err);
    return null;
  }
};

export const getBrandLink = (oldLink: string): string => {
  const filterToRemove = '/filter:ss_product_toggle:1';
  const newLink = oldLink?.replace(filterToRemove, '');
  return newLink;
};
